// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import etoak from './etoak'
import router from './router'
import vuetify from '@/plugins/vuetify'
import store from './store'//引入store
import dialog from './components/dialog/index'
import api from './api/api'
import file from './api/file.js'
import utils from './utils/index.js'
import './plugins/et_icon_font/iconfont'
import PubSub from 'pubsub-js'
import ETIcon from '@/components/ETIcon'
import Print from 'vue-print-nb'

Vue.use(Print)
import ETCharts from '@/components/charts/ETCharts'
import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'

Vue.use(preview)
Vue.component('et-charts', ETCharts)
//全局注册icon-svg
Vue.component('et-icon', ETIcon)
import loader from "vue-ui-preloader";

Vue.use(loader);
Vue.config.productionTip = false
Vue.prototype.$api = api;
Vue.prototype.$file = file;
Vue.prototype.$dialog = dialog;
Vue.prototype.$utils = utils;
Vue.prototype.$publish = PubSub;

/**
 * 自定义指令
 */
Vue.directive('5', {
    inserted: function (el, binding, vnode) {
        if(!store.getters.checkPermissions(binding.value)){
            el.parentNode && el.parentNode.removeChild(el);
        }
    }
})

new Vue({
    router,
    vuetify,
    store,//使用store
    render: h => h(etoak)
}).$mount('#app')

